import { BadgeLayoutProps } from 'framework/ui/uiContract';

export const DEFAULT_TIME_UNITS = {
  HOUR: 'hour',
  DAY: 'day',
};

export const isStatusAllowed = (status: string, skipStates: string[]) => {
  return !skipStates.includes(status);
};

export const getValueWithUnit = (value: any, defaultUnit: string) => {
  const rawResult = `${value} ${defaultUnit}`;
  return value === 1 ? rawResult : `${rawResult}s`;
};

export interface DaysBorderForColor {
  greenBorder: number;
  yellowBorder: number;
  lightRedBorder: number;
}

export const getBadgeColor = (days: number, borders: DaysBorderForColor): BadgeLayoutProps['color'] => {
  const { greenBorder, yellowBorder, lightRedBorder } = borders;

  if (days <= 0) {
    return 'default';
  } else if (days > 0 && days < greenBorder) {
    return 'success';
  } else if (days >= greenBorder && days < yellowBorder) {
    return 'warning';
  } else if (days >= yellowBorder && days < lightRedBorder) {
    return 'error';
  } else {
    return 'error';
  }
};
